import { render, staticRenderFns } from "./CategoryDividersTab.vue?vue&type=template&id=2979104e&"
import script from "./CategoryDividersTab.vue?vue&type=script&lang=js&"
export * from "./CategoryDividersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports